function initializeBackToTopButton() {
    const backToTopButton = document.getElementById("back-on-top");
    if (!backToTopButton) {
        return;
    }
    function smoothScrollToTop(duration = 1000) {
        const startPosition = window.scrollY;
        const startTime = performance.now();
        function scrollStep(currentTime) {
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            window.scrollTo(0, startPosition * (1 - progress));
            if (timeElapsed < duration) {
                requestAnimationFrame(scrollStep);
            }
        }
        requestAnimationFrame(scrollStep);
    }
    function toggleBackToTopButton() {
        if (window.scrollY > 300) {
            backToTopButton.style.display = "flex";
        }
        else {
            backToTopButton.style.display = "none";
        }
    }
    backToTopButton.addEventListener("click", () => {
        smoothScrollToTop();
    });
    window.addEventListener("scroll", toggleBackToTopButton);
    toggleBackToTopButton();
}
export default initializeBackToTopButton;
